import React from "react";
import { useNavigate } from "react-router-dom";
import { handleBack } from "../../../utils/backButton";
import { useSelector } from "react-redux";

const Error503 = () => {
  const navigate = useNavigate();
  const { role } = useSelector((state) => ({
    role: state.auth.role,
  }));
  return (
    <div className="fix-wrapper">
      <div className="container">
        {" "}
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="form-input-content text-center error-page">
              <h1 className="error-text fw-bold">503</h1>
              <h4>
                <i className="fa fa-times-circle text-danger" /> Service
                Unavailable
              </h4>
              <p>Sorry, we are under maintenance!</p>
              <div>
                <button
                  onClick={() => handleBack(role, navigate)}
                  className="btn btn-primary"
                >
                  Back to Home
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error503;
